import React from 'react'
import BeneficiaryContainer from './BeneficiaryContainer'
import classes from './SettingsWrapper.module.css'
import { NavLink, useLocation } from 'react-router-dom'
import { getImageURL, getParentRoute } from '../../util/functions'
import { useSelector } from 'react-redux'
import { userSelectors } from '../../redux/userSlice'
import userAvatar from '../../assets/images/avatar-dark.svg'

const SettingsWrapper = ({ children, title }) => {
    const location = useLocation()
    const path = getParentRoute(location.pathname)

    const user = useSelector(userSelectors.userDetails)

    return (
        <BeneficiaryContainer>
            <div className={classes.titleBar}>
                <h1 className={classes.titleBarText}>{title}</h1>
            </div>
            <div className={classes.contentGrid}>
                <div className={classes.mainContent}>
                    <div className={classes.mainContentNav}>
                        <NavLink
                            to={`${path}/profile`}
                            className={classes.mainContentNavLink}
                            activeClassName={classes.mainContentNavLinkActive}
                        >
                            Profile
                        </NavLink>
                        <NavLink
                            to={`${path}/password`}
                            className={classes.mainContentNavLink}
                            activeClassName={classes.mainContentNavLinkActive}
                        >
                            Password
                        </NavLink>
                    </div>
                    <div className={classes.mainContentBody}>{children}</div>
                </div>
                <div className={classes.sidebar}>
                    <img
                        src={
                            user.profilepicture
                                ? getImageURL(user.profilepicture)
                                : userAvatar
                        }
                        alt="User Avatar"
                        className={classes.sidebarImage}
                    />
                    <h3 className={classes.sidebarUserName}>
                        {user.firstname} {user.lastname}
                    </h3>
                    <h5 className={classes.sidebarUserEmail}>{user.email}</h5>
                    <p className={classes.sidebarUserText}>
                        {user.bio || 'No bio added'}
                    </p>
                </div>
            </div>
        </BeneficiaryContainer>
    )
}

export default SettingsWrapper
